import { render, staticRenderFns } from "./RowActionsCell.vue?vue&type=template&id=95ecbf62&scoped=true&"
import script from "./RowActionsCell.vue?vue&type=script&lang=js&"
export * from "./RowActionsCell.vue?vue&type=script&lang=js&"
import style0 from "./RowActionsCell.vue?vue&type=style&index=0&id=95ecbf62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ecbf62",
  null
  
)

export default component.exports